<template>
  <div class="container">
    <div class="row row-cards">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Rechercher par adresse</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="form-label">Adresse</label>
                  <div class="input-group mb-2">
                    <input type="text" class="form-control" v-model="adresseRecherche" name="adresseRecherche" v-validate="'required'" 
                      :class="{ 'is-invalid': errors.has('adresseRecherche') }" data-vv-as="L'adresse" ref="password" 
                      v-on:keyup.enter.prevent="rechercherAdresse()">
                    <span class="input-group-append">
                      <button class="btn btn-primary" type="button" v-on:click.prevent="rechercherAdresse()">
                        Rechercher
                      </button>
                    </span>
                  </div>
                  <div class="invalid-feedback" v-show="adresseErreur">
                    {{ adresseErreur }}
                  </div>
                </div>
                <div class="form-group" v-if="adresseTrouve && horaireTrouve">
                  <label class="form-label mb-0">Horaire pour l'adresse</label>
                  <!-- <small><i>{{ adresseTrouve.display_name }}</i></small><br> -->
                </div>

                <div class="card" v-bind:style="{ display: showCalendar?'block':'none' }">
                  <div class="card-header" v-if="horaireTrouve">
                    <h2 class="card-title">{{ horaireTrouve.nom }}</h2>
                  </div>
                  <div class="card-body">
                    <div class="fc-calendar-header">
                      <h3 class="fc-calenday-month-year">{{ monthYear }}</h3>
                      <div class="float-right">
                        <button class="btn btn-secondary btn-sm" type="button" 
                          v-on:click.prevent="calPrev()"> Précédent </button>
                        <button class="btn btn-secondary btn-sm" type="button" 
                          v-on:click.prevent="calNext()"> Suivant </button>
                      </div>
                      <div class="clear-fix"></div>
                    </div>

                    <div class="horaire-container">
                      <div id="outer-calendar"></div>
                    </div>
                  </div>
                </div>

                <div class="card" v-bind:style="{ display: showMap?'block':'none' }">
                  <div class="card-header" v-if="ecocentreTrouve">
                    <h2 class="card-title">{{ ecocentreTrouve.nom }}</h2>
                  </div>
                  <div class="card-body pt-4">
                    <div class="pb-3" v-if="ecocentreTrouve">
                      <b>Adresse:&nbsp;&nbsp;</b>{{ ecocentreTrouve.adresse }}
                    </div>

                    <div style='position:relative;'>
                      <div id="map_div" style="height: 600px; width:100%;"></div>
                      <div id='cp-wrap'></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  mounted() {
    this.initMap();
  },
  data() {
    return {
      loading: false,
      adresseRecherche: "202 rue Saint-Joseph, Saint-Raymond",
      adresseErreurTexte: null,
      adresseTrouve: null,
      horaireTrouve: null,
      showCalendar: false,
      calendarData: [],
      loadedYears: [],
      monthYear: '',
      ecocentreTrouve: null,
      showMap: false,
    }
  },
  computed: {
    adresseErreur() {
      return this.adresseErreurTexte || this.errors.first('adresseRecherche');
    }
  },
  methods: {
    rechercherAdresse() {
      var self = this;
      self.adresseErreurTexte = null;
      self.adresseTrouve = null;
      self.showCalendar = false;
      self.showMap = false;

      self.$validator.validateAll().then((result) => {
        if(result) {
          // Obtenir les adresses correspondantes sur OSM
          $.get( "https://nominatim.openstreetmap.org/search.php", {
            q: self.adresseRecherche,
            format: "json"
          }, function( data ) {
            if (data) {
              var results = data.filter(result => {
                return (result.display_name.indexOf('Canada') > -1 &&
                  result.display_name.indexOf('Québec') > -1);
              });

              if (results.length == 1) {
                self.adresseTrouve = result;
                var result = results[0];
                var pointData = {
                  lat: result.lat,
                  lng: result.lon
                };

                // Obtenir la zone associée à ces coordonnées
                Promise.all([ 
                  self.$http.post('horaires/search', pointData),
                  self.$http.post('ecocentres/search', pointData),
                ]).then(function([ horaireRes, ecocentreRes ]) {
                  if (horaireRes.status == 200) {
                    let res = horaireRes.body;
                    if (res && res.found && res.horaire) {
                      var horaire = res.horaire;
                      self.horaireTrouve = horaire;
                      self.resetCalendar();
                    } else {
                      self.adresseErreurTexte = 
                        "Cette adresse n'est pas dans une zone couverte par la régie.";
                    }
                  }
                  
                  if (ecocentreRes.status == 200) {
                    let res = ecocentreRes.body;
                    if (res && res.ecocentre) {
                      var ecocentre = res.ecocentre;
                      self.ecocentreTrouve = ecocentre;
                      self.updateEcocentrePosition();
                    }
                  }
                }).catch(function (err){
                  console.log(err);
                });

              } else if (results.length > 1) {
                self.adresseErreurTexte = 
                  "L'adresse n'est pas assez précise.";
              } else {
                self.adresseErreurTexte = 
                  "L'adresse n'a pas été trouvée.";
              }
            }
          });
        }
      });
    },

    loadYear(year) {
      var self = this;
      var yearExists = $.inArray(year, this.loadedYears) !== -1;
      if (this.cal && !yearExists) {
        Promise.all([ 
          self.$http.get('types_collectes'),
          self.$http.get(`horaires/dates/${self.horaireTrouve.id}`, { params: {
            annee: year
          }}),
        ]).then(function([ typesRes, datesRes ]) {
          var types = [];
          if (typesRes && typesRes.body && typesRes.body.data)
            types = typesRes.body.data
          var dates = [];
          if (datesRes && datesRes.body && datesRes.body.data)
            dates = datesRes.body.data

          var datesGrouped = {};
          for (var i = 0; i < dates.length; i++) {
            let date = dates[i];
            let dateObj = new Date(date.date.replace(new RegExp('-','g'),'/'));
            let ymd = self.getFormattedDate(dateObj);
            if (!datesGrouped.hasOwnProperty(ymd)) { datesGrouped[ymd] = []; }
            let type = types.find(t => t.id == date.type_id);
            if (type) {
              datesGrouped[ymd].push({
                ...date,
                type_icone: type.icone_path,
                type_couleur: type.couleur,
                type_nom: type.nom,
              });
            }
          }

          var calData = {};
          var  datesKeys = Object.keys(datesGrouped);
          for (var i = 0; i < datesKeys.length; i++) {
            let key = datesKeys[i];
            let elements = datesGrouped[key];
            calData[key] = elements.map(el => {
              var type_name = el.type_nom;
              if (el.type_icone) type_name = `<span class="helper">`+
                `</span><img src="${self.$storage(el.type_icone)}" alt="">`;
              return `<div style="background-color: ${el.type_couleur};`+
                `height:${(100/elements.length).toFixed(4)}%" class="fc-element">`+type_name+'</div>';
            }).join('');
          }

          self.loadedYears.push(year);
          self.calendarData = calData;
          if (self.cal) {
            self.cal.setData(self.calendarData);
          }
        }).catch(function (err){
          console.log(err);
        });
      }
    },

    getFormattedDate(date) {
      var year = date.getFullYear();
      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;
      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      return month + '-' + day + '-' + year;
    },
    resetCalendar() {
      if (this.cal) {
        $('#outer-calendar').html('');
        setTimeout(this.initCalendar, 200);
      } else {
        this.initCalendar();
      }
    },
    initCalendar() {
      $('#outer-calendar').html('<div id="calendar" class="fc-calendar-container"></div>');
      this.showCalendar = true;
      this.cal = $( '#calendar' ).calendario({
        weeks : [ "Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi" ],
        weekabbrs : [ "Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam" ],
        months : [ "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", 
          "Août", "Septembre", "Octobre", "Novembre", "Décembre" ],
        monthabbrs : [ "Jan", "Fév", "Mar", "Avr", "Mai", "Jui", "Jul", "Aou", "Sep", "Oct", "Nov", "Déc" ] });
      this.calendarData = [];
      this.loadedYears = [];
      this.updateMonthYear();
    },
    calNext() { if (this.cal) this.cal.gotoNextMonth( this.updateMonthYear ); },
    calPrev() { if (this.cal) this.cal.gotoPreviousMonth( this.updateMonthYear ); },
    updateMonthYear() {       
      if (this.cal) {
        var year = this.cal.getYear();
        this.monthYear = this.cal.getMonthName() + ' ' + year;
        this.loadYear(year);
      }
    },

    initMap() {
      this.map = new google.maps.Map(document.getElementById("map_div"), {
        center: new google.maps.LatLng("46.799319","-71.743374"),
        mapTypeId: google.maps.MapTypeId.HYBRID,
        zoom: parseFloat(11),
        streetViewControl: false
      });
    },
    updateEcocentrePosition() {
      var ecocentre = this.ecocentreTrouve;
      if (this.map && ecocentre) {
        this.showMap = true;
        if (this.marker) this.marker.setMap(null);
        var position = new google.maps.LatLng(
          parseFloat(ecocentre.lat), parseFloat(ecocentre.lng));
        this.map.setCenter(position);
        this.map.setZoom(15);
        this.marker = new google.maps.Marker({
          map: this.map,
          position: position
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Recherche.vue?b2739c8a